import * as React from "react";
const SvgAdd = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.752 6.444v4.308H2.136v2.496h8.616v8.616h2.496v-8.616h8.616v-2.496h-8.616V2.136h-2.496v4.308Z", fill: "currentColor" })));
export default SvgAdd;
